import { ReactNode, createContext, useContext } from 'react';

import { wacToken } from '../foundations';

interface ThemeContextValue {
	isDarkTheme: boolean;
	isDevTheme: boolean;
	isAwf1Theme: boolean;
}

const ThemeContext = createContext<ThemeContextValue>({
	isDarkTheme: false,
	isDevTheme: false,
	isAwf1Theme: false,
});

export const useTheme = () => useContext(ThemeContext);

interface ThemeProviderProps {
	isDarkEnabled: boolean;
	isDevEnabled?: boolean;
	isAwf1Enabled?: boolean;
	children: ReactNode;
}

const darkThemeStyles: React.CSSProperties = {
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
	['--wac-color-heading' as string]: wacToken('color.neutral.light0'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
	['--wac-color-body' as string]: wacToken('color.neutral.light0'),
	backgroundColor: wacToken('color.neutral.dark100'),
};

export const ThemeProvider = ({
	isDarkEnabled,
	isDevEnabled = false,
	isAwf1Enabled = false,
	children,
}: ThemeProviderProps) => {
	return (
		<ThemeContext.Provider
			value={{ isDarkTheme: isDarkEnabled, isDevTheme: isDevEnabled, isAwf1Theme: isAwf1Enabled }}
		>
			<div style={isDarkEnabled ? darkThemeStyles : undefined}>{children}</div>
		</ThemeContext.Provider>
	);
};
